import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
const user = {
  state: {
    token: getToken(),
    name: '',
    phone: '',
    avatar: '',
    roles: [],
    permissions: ["*:*:*"],
    powerList: [],
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_MERCHANT: (state, merchant) => {
      state.merchant = merchant
    },
    SET_POWER_LIST: (state, power) => {
      state.powerList = power
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise(async (resolve, reject) => {
        login(userInfo).then(res => {
          if (res.code == 200) {
            setToken(res.data.token)
            commit('SET_TOKEN', res.data.token)
            resolve()
          }else{
            reject(res)
          }

        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          console.log(res, "--->res用户信息");
          if (res.code == 200) {
            commit('SET_NAME', res.data.username)
            commit('SET_AVATAR', res.data.avatar)
            commit('SET_PHONE', res.data.phone)
            commit('SET_ROLES', [res.data.role_id])
            commit('SET_MERCHANT', res.data.merchant ? res.data.merchant : res.data.on_line_merchant)
            commit('SET_POWER_LIST', res.data.power)
            resolve(res)
          } else {
            return reject(res)
          }

          // const user = res.user
          // const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/images/profile.jpg") : process.env.VUE_APP_BASE_API + user.avatar;
          // if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
          //   commit('SET_ROLES', res.roles)
          //   commit('SET_PERMISSIONS', res.permissions)
          // } else {
          //   commit('SET_ROLES', ['ROLE_DEFAULT'])
          // }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    logOutTwo({ commit, state }) {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      commit('SET_PERMISSIONS', [])
      removeToken()
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
